import { render, staticRenderFns } from "./VariablesHeader.vue?vue&type=template&id=07fe1b7a&"
import script from "./VariablesHeader.vue?vue&type=script&lang=js&"
export * from "./VariablesHeader.vue?vue&type=script&lang=js&"
import style0 from "./VariablesHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports